module.exports = __webpack_public_path__ + "static/media/square-full-readonly.718dc615.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/square-full-readonly.svg
// module id = 760
// module chunks = 0